import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Flex,
  H1,
  H2,
  HeaderInfo,
  HeaderInfoElement,
  Text,
  Tooltip,
} from '@erecruit/ui-kit';
import { ThemedLink, ColoredCircle, Authorize } from '@erecruit/modules';
import { AppPermissions } from '@erecruit/types';
import { Intl } from '@erecruit/core';
import { ShiftRecordProps } from '../types';

const { FormattedMessage } = Intl;

const ShiftRecordHeader: FC<ShiftRecordProps> = props => {
  const { id } = useParams();
  const { infoSection } = props;
  const description = infoSection?.general.description;
  const position = infoSection?.general.position;
  const shiftStatus = infoSection?.general.shiftStatus;
  const company = infoSection?.general.company;

  return (
    <Container gutter={4} background="pageSecondary">
      <Breadcrumb>
        <BreadcrumbItem>
          <Flex align="center" gutter={2}>
            <H1>{description}</H1>
            <H2 padding={[0, 0, 3, 0]}>{`(${id})`}</H2>
          </Flex>
        </BreadcrumbItem>
      </Breadcrumb>
      <HeaderInfo>
        <HeaderInfoElement
          label={
            <Tooltip
              overlay={
                <Flex padding={2} align="center" gutter={2}>
                  <Text>
                    <FormattedMessage
                      id={messageIds.vms.shiftRecord.shiftStatus}
                    />
                  </Text>
                  <Text weight={700}>{shiftStatus?.name}</Text>
                </Flex>
              }
            >
              <Flex gutter={2} align="center">
                <ColoredCircle size={8} color={shiftStatus?.color} />
                <span>{shiftStatus?.name}</span>
              </Flex>
            </Tooltip>
          }
        />
        <HeaderInfoElement
          tooltip={
            <FormattedMessage id={messageIds.vms.shiftRecord.position} />
          }
          label={
            <Authorize
              permission={`${AppPermissions.ViewPositions} & ${AppPermissions.ViewPosition}`}
            >
              {(isAuthorized: boolean) =>
                isAuthorized ? (
                  <ThemedLink to={`/shifts/position/${position?.id}`}>
                    {`${position?.name} (${position?.id})`}
                  </ThemedLink>
                ) : (
                  <Text>{position?.name}</Text>
                )
              }
            </Authorize>
          }
        />
        <HeaderInfoElement
          tooltip={<FormattedMessage id={messageIds.vms.shiftRecord.company} />}
          label={company?.name}
          icon="company"
        />
      </HeaderInfo>
    </Container>
  );
};

export default ShiftRecordHeader;
